export enum CountriesDataVariant {
  ALL = "all",
  SWITZERLAND_AND_NEIGHBORS = "switzerlandAndNeighbors",
}
